import moment from 'moment/moment';

export default async function autoPassengersFormSet({
  passengersForm,
  statementRide,
  isCustomerBooking = false,
}) {
  if (statementRide) {
    passengersForm.setFieldValue('passengers', statementRide?.statementSeats
      ?.filter((seat) => {
        if (isCustomerBooking) {
          return seat?.statementSeatDetail;
        }
        return seat?.id;
      })?.map((seat) => {
        const seatDetails = isCustomerBooking ? seat.statementSeatDetail : seat;
        const values = {
          seat_number: seatDetails?.seatNumber,
          carriage_id: seatDetails?.carriageId,
          initial_seat_price: seat?.paymentAmount,
          seat_class: seatDetails?.seatClass?.id,
          seat_group_property_id: seatDetails?.seatGroupPropertyId,
          carriage_order_number: seatDetails?.carriageOrderNumber,
          seat_id: seat?.id,
        };
        if (seatDetails?.passenger?.passengerFirstName) {
          values.first_name = seatDetails?.passenger?.passengerFirstName;
        }
        if (seatDetails?.passenger?.passengerLastName) {
          values.last_name = seatDetails?.passenger?.passengerLastName;
        }
        if (seatDetails?.passenger?.passengerCode) {
          values.id_number = seatDetails?.passenger?.passengerCode;
        }
        if (seatDetails?.passenger?.passengerDateOfBirth) {
          values.birth_date = moment(seatDetails?.passenger?.passengerDateOfBirth);
        }

        return values;
      }));
  }
}
